export const categories = [
  {
    slug: "xing-jian-kang-jiao-yu",
    name: "性健康教育",
    description: "科学、系统地了解性健康知识，消除误解与偏见，建立正确的性观念。",
    icon: "ri-mental-health-line",
    color: "primary",
    articleCount: 28,
  },
  {
    slug: "qin-mi-guan-xi-zhi-dao",
    name: "亲密关系指导",
    description: "改善伴侣沟通，增进情感连接，解决亲密关系中的困惑与矛盾。",
    icon: "ri-heart-pulse-line",
    color: "accent",
    articleCount: 35,
  },
  {
    slug: "xing-gong-neng-kun-rao",
    name: "性功能困扰",
    description: "针对勃起功能障碍、早泄、性欲低下等常见问题提供专业指导方案。",
    icon: "ri-stethoscope-line",
    color: "secondary",
    articleCount: 42,
  },
  {
    slug: "xing-xin-li-jian-kang",
    name: "性心理健康",
    description: "处理性焦虑、性创伤、性取向困惑等心理层面的问题，重建健康的性自我认知。",
    icon: "ri-brain-line",
    color: "primary",
    articleCount: 31,
  },
  {
    slug: "hun-yin-jia-ting-zi-xun",
    name: "婚姻家庭咨询",
    description: "解决婚姻中的性生活不和谐、家庭关系紧张等复合型问题。",
    icon: "ri-home-heart-line",
    color: "accent",
    articleCount: 24,
  },
  {
    slug: "qing-chun-qi-xing-jiao-yu",
    name: "青春期性教育",
    description: "为青少年和家长提供科学的青春期性教育指导，帮助顺利度过成长关键期。",
    icon: "ri-seedling-line",
    color: "secondary",
    articleCount: 19,
  },
];